/**
 * Adds source code to any Erthhour buttons.
 *
 * @param {string} sourcecode
 *   The sourcecode
 */
const addSourceCodeToEarthHourButtons = (sourcecode) => {
  const { links } = document;

  for (let j = links.length - 1; j >= 0; j -= 1) {
    const link = links[j].href;

    if (
      link.endsWith("/sign-up") ||
      link.endsWith("/earthhour") ||
      link.endsWith("/earthhour/")
    ) {
      links[j].href = `${link}?pc=${sourcecode}`;
    }
  }
};

export default addSourceCodeToEarthHourButtons;
